import { useCourseModule } from './useCourseModule';
import CourseCertificatePage from '../CourseCertificatePage';

export default function ModuleCertificate() {
  const { apiBase, learnerBase } = useCourseModule();
  return <CourseCertificatePage apiBase={apiBase} homePath={learnerBase} courseBase={`${learnerBase}/course`} />;
}
